import { createTokens } from "../utils";
var FONT = '"Open Sans", sans-serif';
var LIGHTER = '200';
var NORMAL = '400';
var SEMI_BOLD = '600';
var BOLD = '700';
export var typo = createTokens('vm-typo', {
    typoFontFamily: FONT,
    typoBaseFont: NORMAL + " 13px/16px " + FONT,
    typoFontWeightLighter: LIGHTER,
    typoFontWeightNormal: NORMAL,
    typoFontWeightSemiBold: SEMI_BOLD,
    typoFontWeightBold: BOLD,
    typoFontSizeS: '12px',
    typoFontSizeM: '13px',
    typoFontSizeL: '15px',
    typoFontSizeXL: '21px',
    typoFontXL: NORMAL + " 21px/26px " + FONT,
    typoFontL: NORMAL + " 15px/18px " + FONT,
    typoFontLBold: BOLD + " 15px/18px " + FONT,
    typoFontMain: NORMAL + " 13px/16px " + FONT,
    typoFontMainSemiBold: SEMI_BOLD + " 13px/16px " + FONT,
    typoFontMainBold: BOLD + " 13px/16px " + FONT,
    typoFontSecondary: NORMAL + " 12px/14px " + FONT,
    typoFontSecondarySemiBold: SEMI_BOLD + " 13px/16px " + FONT,
    typoFontSecondaryBold: BOLD + " 12px/14px " + FONT,
    typoFontList: NORMAL + " 13px/24px " + FONT,
    typoFontBulletedList: NORMAL + " 13px/20px " + FONT,
    typoFontNumberList: NORMAL + " 13px/20px " + FONT
});
//# sourceMappingURL=typo.js.map